<template>
    <div>
        <li class="group-child-node" @click="onSelectItem(objIn)">
            <span class="fa-li" @click="onOpen($event)"><i class="fa" :class="{'fa-sort-down': open, 'fa-plus-square': !open}" v-if="objIn[children] && objIn[children].length"></i></span>
            <p class="fa-li-name" :style="[selected ? {'font-weight': 'bold', paddingLeft: indent + 'px'} : {paddingLeft: indent + 'px'}]">{{objIn.name}}</p>
        </li>

        <design-2021-apprentice-tree-view-component
                :data="objIn[children]"
                :children="children"
                :key="objIn.id"
                :indent="indent"
                :navigate-to-element="navigateToElement"
                v-show="objIn[children] && objIn[children].length && open" @open="openList">
        </design-2021-apprentice-tree-view-component>
    </div>
</template>

<script>

    import { CommonBus } from '../../../app';

    export default {
        name: "design-2021-apprentice-tree-view-node-component",
        props:{
            'objIn': {
                required: true
            },
            'children': {
                default: 'children'
            },
            'indentIn': {
                required: true
            },
            'openIn': {
                default: false
            },
            navigateToElement: {
                default: true
            }
        },
        data () {
            return {
                selected: false,
                open: this.openIn,
                indent: this.indentIn + 10
            }
        },
        methods: {
            onSelectItem(item) {
                if (this.navigateToElement) {
                    CommonBus.$emit('tree-view-selected-item', item);
                }
            },
            openList() {
                this.open = true;
                this.$emit('open');
            },
            onOpen(e) {
                e.stopPropagation();
                this.open = !this.open;
            }
        },
        created() {
            CommonBus.$on('tree-view-selected-item', (item) => {
                if (item.id === this.objIn.id) {
                    this.selected = (true);
                    this.$emit('open');
                } else {
                    this.selected = false;
                }
            })
        }
    }
</script>

<style scoped lang="scss">

    .group-child-node {
        font-size: $default-font-size;
        line-height: 1.8;
        border-bottom: 1px solid $border-color;
        overflow: hidden;
        text-overflow: ellipsis;

        .fa-li {
            left: 8px !important;
        }
    }

    li {
        padding: map-get($grid-gutter-spacing, '0');

        &:hover {
            cursor: pointer;
            background-color: $secondary-background-color;
        }
    }

</style>
